import axios from 'axios'
const url = '/clientes/cliente'
export default {
    index(params = {}) {
        return axios.get(`${url}`, { params });
    },


    show(id) {
        return axios.get(`${url}/${id}`)
    },
    create(data) {

        return axios.post(`${url}`, data)
    },
    createRapido(data) {
        return axios.post('/clientes/rapido', data)
    },
    // Edición de quién es el cliente y cómo se lo contacta. Distinta del PUT
    // genérico: escribe el Cliente y sincroniza su Persona.
    editarBasico(id, data) {
        return axios.put(`/clientes/${id}/basico`, data)
    },
    updateContable(data) {
        const url = '/clientes/contable'
        return axios.put(`${url}/${data.id}`, data)

    },

    update(data) {
        return axios.put(`${url}/${data.id}`, data)
    },



    delete(id, data) {
        return axios.delete(`${url}/${id}`, data)


    },

}